import axios from "axios";
import { fetchUsageSummary } from "./usageService";

const DEV_CUSTOMER_URL =
  "https://n4kl7g5v9i.execute-api.us-east-1.amazonaws.com/Prod/customers";
const PROD_CUSTOMER_URL =
  "https://customers.api.sagelyn.ai/customers";

const BASE_URL =
  process.env.REACT_APP_CUSTOMER_API_URL ||
  (process.env.REACT_APP_ENV === "development" ? DEV_CUSTOMER_URL : PROD_CUSTOMER_URL);

export const TOPUP_PRESETS = [15, 30, 50, 100, 250, 500];

export interface AutoRefillSettings {
  auto_refill_enabled: boolean;
  auto_refill_threshold: number;
  auto_refill_amount: number;
}

export interface TopupSessionResponse {
  url: string;
  session_id: string;
}

export const getBalance = async (
  customerId: string,
  idToken: string
): Promise<number> => {
  const summary = await fetchUsageSummary(customerId, idToken);
  return summary.credit_balance ?? 0;
};

export const createTopupSession = async (
  customerId: string,
  amount: number,
  idToken: string
): Promise<TopupSessionResponse> => {
  const response = await axios.post<TopupSessionResponse>(
    `${BASE_URL}/${customerId}/credits/topup`,
    { amount },
    { headers: { Authorization: `Bearer ${idToken}` } }
  );
  return response.data;
};

export const updateAutoRefill = async (
  customerId: string,
  settings: AutoRefillSettings,
  idToken: string
): Promise<void> => {
  await axios.put(
    `${BASE_URL}/${customerId}`,
    {
      customer_id: customerId,
      auto_refill_enabled: settings.auto_refill_enabled,
      auto_refill_threshold: settings.auto_refill_threshold,
      auto_refill_amount: settings.auto_refill_amount,
    },
    { headers: { Authorization: `Bearer ${idToken}` } }
  );
};
